import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { ContractInput } from '../../context/types';
import { CodesSection, SectionReadiness } from '../codes';

interface CaseRateDisplayProps {
  input: ContractInput;
  onReady: (readiness: SectionReadiness) => void;
}

export const CaseRateDisplay = ({
  input,
  onReady,
}: CaseRateDisplayProps): JSX.Element => (
  <HHStack spacing={1}>
    <HHStack spacing={0.5}>
      <HHTypography hhVariant="subtitle1">Procedures</HHTypography>
      <HHTypography hhVariant="caption" sx={{ opacity: 0.65 }}>
        Resolve the input&apos;s procedure codes to billable items.
      </HHTypography>
    </HHStack>
    <CodesSection codes={input.fee_schedule.codes} onReady={onReady} />
  </HHStack>
);
